import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-20 md:pt-32 pb-10 md:pb-20 px-4 md:px-12 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-56">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-57">
        <div className="inline-block mb-4 md:mb-6 px-4 py-1 border border-gold-500/30 rounded-full text-gold-500 text-sm font-medium tracking-widest uppercase" data-id="element-58">
          El Edutainment OS
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-black leading-tight mb-5 md:mb-8 text-offwhite" data-id="element-59">
          Cómo Crear Videos Educativos Estilo "Ted-Ed" con IA en Menos de 1
          Hora, <span className="text-gold-500 italic" data-id="element-60">Sin Pagar Editores</span>{' '}
          y Sin Software Complejo
        </h1>
        <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto mb-8 md:mb-12 font-light leading-relaxed" data-id="element-61">
          No es un curso de edición. Es un sistema de "copiar y pegar" para
          transformar tu conocimiento en experiencias visuales de alta gama que
          el cerebro de tu audiencia no puede ignorar.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      delay: 0.3
    }} className="relative w-full max-w-4xl" data-id="element-62">
        <div className="absolute inset-0 bg-gold-500/10 blur-3xl rounded-full -z-10" data-id="element-63"></div>
        <img src="https://cdn.magicpatterns.com/uploads/uFg6KoPXaxtguq7Qpzbzoa/MK_1.png" alt="Edutainment OS Book and Tablet" className="w-full h-auto rounded-lg shadow-2xl border border-white/5" data-id="element-64" />
      </motion.div>
    </section>;
}